module.exports = __webpack_public_path__ + "static/media/car.6b3111e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/car.jpg
// module id = 291
// module chunks = 0